export const getEntityColor = (entityType: 'geo' | 'related' | 'media') => {
  if (entityType === 'geo') {
    return '#4CAF50';
  } else if (entityType === 'media') {
    return '#2196F3';
  } else {
    return 'white';
  }
};

function hashCode(str: string) {
    let hash = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        let chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

// Add function to generate colors for different categories (same as SingleItemPreview)
export const getCategoryColor = (category: string) => {
  try {
    // Create a hash of the category name to get a consistent number
    const hash = hashCode(category);

    // Normalize hash to a value between 0 and 1
    const normalizedHash = Math.abs(hash) / 2147483647;

    // Use a predefined array of safe color values
    const colorOptions = [
      '#1976d2', // primary
      '#004ba0', // primary dark
      '#63a4ff', // primary light
      '#9c27b0', // secondary
      '#6a0080', // secondary dark
      '#d05ce3', // secondary light
      '#2196f3', // info
      '#4caf50', // success
      '#ff9800', // warning
      '#a200ff',
      '#00bcd4',
      '#009688',
      '#8bc34a',
      '#cddc39'
    ];

    // Use the hash to pick a color
    const colorIndex = Math.floor(normalizedHash * colorOptions.length);
    return colorOptions[colorIndex];
  } catch (error) {
    // Fallback to a safe default color
    return '#1976d2';
  }
};